import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { stringIsNullOrEmpty } from '../../utils/strings';

export default withStyles({})(({ variant, topText, data, bottomText }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `data--${variant}`;

    return (
        <div className="data-highlight">
            <p>{topText}</p>
            <p className={`data ${cssVariant || ''}`}>{data}</p>
            <p>{bottomText}</p>
        </div>
    );
});
